import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { GenericHttpService } from "./../../shared/services/generic-http.service";
import { environment } from "./../../../environments/environment";
import { ApiUrlConstant } from "./../../shared/constants/api-url.constant";
import { SettingsConstant } from "../../shared/constants/settings.constants";
import { LocalStorageService } from "../../shared/services/local-storage.service"
import { GenericUtils } from "../../shared/utilities/generic-utils"
import { Router } from "@angular/router";

@Injectable(
  {
    providedIn: "root"
  }
)
export class LoginService {
  apiUrl = environment.UMS_HOST;
  editItem: any;

  constructor(
    private http: GenericHttpService,
    private endPoints: ApiUrlConstant,
    private localStorage: LocalStorageService,
    private utils: GenericUtils,
    private router: Router

  ) { }

  login(body) {

    const option = {
      method: "POST",
      url: `${this.apiUrl}${this.endPoints.LOGIN_BY_USERNAME_PASSWORD}`,
      skipAuthorization: true,
      body
    };
    return this.http.httpRequest(option).pipe(
      catchError(this.http.handleError),
      map(this.http.responseData)
    );
  }

  forgotPassword(body) {

    const option = {
      method: "POST",
      url: `${this.apiUrl}${this.endPoints.FORGOT_PASSWORD}`,
      skipAuthorization: true,
      body
    };
    return this.http.httpRequest(option).pipe(
      catchError(this.http.handleError),
      map(this.http.responseData)
    );
  }

  public logOut(): void {
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN
    );
    this.localStorage.removeItem(SettingsConstant.LOCALSTORAGE_KEYS.ID_TOKEN);
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES
    );
    this.localStorage.removeItem(SettingsConstant.LOCALSTORAGE_KEYS.USER_UUID);
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.USER_PERMISSION
    );
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS
    );
    this.localStorage.removeItem(SettingsConstant.LOCALSTORAGE_KEYS.EXPIRES_AT);
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT
    );

    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.CLIENT_LIST
    );

    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.COOKIE_TOKEN
    );
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.UMS_APP_TOKEN
    );

    const umsTokenName = `${environment.accessToken}`;
    this.utils.storeCookie(umsTokenName, '', new Date(-1), this.utils.getSubDomainName());
    this.localStorage.removeItem("PAGE_WIDGET_DATA");
    this.router.navigate(['/login'], { replaceUrl: true });

  }

  public isAuthenticated(): boolean {
    const expiresAt = JSON.parse(
      localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.EXPIRES_AT)
    );
    return new Date().getTime() < expiresAt;
  }
}
